import Radio from "components/shared/inputs/radio";
import { memo } from "react"

const Radio1 = props => {
    const localChangeHandler = newValue => {
        if (newValue === props.value)
            props.changeHandler(null);
        else
            props.changeHandler(newValue);
    }

    return (
        <div className="cat-holder">
            <span className="label tp-27">{props.label}</span>

            {
                props.options.map((radio, i) => (
                    <Radio
                        key={`radio-${radio.value}-${i}`}
                        label={radio.title}
                        name={props.name}
                        value={radio.value}
                        clickHandler={() => localChangeHandler(radio.value)}
                        // eslint-disable-next-line
                        checked={radio.value == props.value}
                    />
                ))
            }
        </div>
    )
}

export default memo(Radio1); 